import { Button, Card, CardContent, CardHeader, CardTitle } from "@repo/ui";
import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

interface RegistrationTimelineChartProps {
  data: Array<{
    date: string;
    การลงทะเบียน: number;
  }>;
  granularity: "daily" | "hourly";
  onGranularityChange: (granularity: "daily" | "hourly") => void;
  isLoading?: boolean;
}

export function RegistrationTimelineChart({
  data,
  granularity,
  onGranularityChange,
  isLoading = false,
}: RegistrationTimelineChartProps) {
  return (
    <Card>
      <CardHeader>
        <div className="flex flex-col gap-3">
          <div className="flex items-center justify-between">
            <CardTitle>การลงทะเบียน{granularity === "hourly" ? "รายชั่วโมง" : "รายวัน"}</CardTitle>
          </div>
          <div className="flex gap-2">
            <Button
              size="sm"
              variant={granularity === "daily" ? "default" : "outline"}
              onClick={() => onGranularityChange("daily")}
            >
              รายวัน
            </Button>
            <Button
              size="sm"
              variant={granularity === "hourly" ? "default" : "outline"}
              onClick={() => onGranularityChange("hourly")}
            >
              รายชั่วโมง
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="h-80 flex items-center justify-center text-muted-foreground">
            กำลังโหลด...
          </div>
        ) : data.length === 0 ? (
          <div className="h-80 flex items-center justify-center text-muted-foreground">
            ไม่มีข้อมูล
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={320}>
            <AreaChart data={data}>
              <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
              <XAxis
                dataKey="date"
                className="text-xs"
                tick={{ fill: "hsl(var(--muted-foreground))" }}
              />
              <YAxis className="text-xs" tick={{ fill: "hsl(var(--muted-foreground))" }} />
              <Tooltip
                contentStyle={{
                  backgroundColor: "hsl(var(--background))",
                  border: "1px solid hsl(var(--border))",
                  borderRadius: "6px",
                }}
              />
              <Legend />
              <Area
                type="monotone"
                dataKey="การลงทะเบียน"
                stroke="hsl(221, 83%, 53%)"
                fill="hsl(221, 83%, 53%)"
                fillOpacity={0.6}
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
}
